import type { Item } from '../types/main';
import type { EmitsEventName } from '../types/internal';

export default function useMiddleClickRow(
  emits: (event: EmitsEventName, ...args: unknown[]) => void,
) {
  const middleClickRow = (item: Item, $event: MouseEvent) => {
    if ($event.button === 1) {
      $event.preventDefault();
      $event.stopPropagation();
      emits('middleclickRow', { ...item }, $event);
    }
  };

  return {
    middleClickRow,
  };
}
